<template>
    <QuoteAndDraft/>
  </template>
  
  <script>
  import QuoteAndDraft from "@/components/Ondemand/Bookings/QuoteAndDraft.vue";
  
  export default {
    components: {
        QuoteAndDraft,
    },
  };
  </script>
  
  <style></style>